export default __webpack_public_path__ + "static/media/Reward_crown.89cb089b.svg";